module.exports = __webpack_public_path__ + "static/media/retirement-age.f6d48040.svg";